import styled from 'styled-components'
import { Button as YogaButton } from '@gympass/yoga'
import getBreakpoint from '@client/utils/breakpoints'

export const MapWrapper = styled.section`
  position: relative;
  width: 100%;
  height: 100%;
`

export const FilterByPlanWrapper = styled.section`
  position: absolute;
  top: 24px;
  right: 22px;
  width: auto;
  z-index: 1;
`

export const PlanDetailWrapper = styled.section`
  position: absolute;
  top: 112px;
  right: 22px;
  width: 314px;
  z-index: 1;
`

export const AddressFieldWrapper = styled.section`
  position: absolute;
  top: 24px;
  left: 20px;
  width: calc(100% - 40px);

  z-index: 1;
  height: 68px;

  display: flex;
  align-items: center;
  padding: 10px;
  box-shadow: 0px 2px 6px rgba(152, 152, 167, 0.25);
  border-radius: 100px;
  background: #ffffff;
  box-sizing: border-box;

  @media (min-width: ${getBreakpoint('xl')}px) {
    width: 380px;
    left: 22px;
  }
`

export const AddressFieldAction = styled.button`
  width: 48px;
  height: 48px;
  border: 0;
  border-radius: 100%;
  background-color: transparent;
  cursor: pointer;

  &:focus,
  &:hover {
    background-color: rgba(25, 104, 201, 0.1);
    outline: 0;
  }
`

export const FilterTitle = styled.p`
  font-family: Lato;
  font-style: normal;
  font-weight: 800;
  font-size: 18px;
  line-height: 20px;
  margin: 20px 0 0;
`

export const PlanFilterModalWrapper = styled.section`
  margin-top: 24px;
`

export const DividerWrapper = styled.section`
  margin-top: 16px;
  margin-bottom: 32px;
`

export const ModalContent = styled.section`
  flex: 1;
  overflow-y: scroll;
  padding: 20px 20px 0;
`

export const ModalAction = styled.section`
  flex: 0;
  padding: 20px;
`
export const ModalButton = styled(YogaButton)`
  background-color: ${({ white }) =>
    white ? 'var(--white)' : 'var(--sao-paulo-60)'};
  color: ${({ white }) => (white ? 'var(--sao-paulo-60)' : 'var(--white)')};
  border-color: var(--sao-paulo-60);

  &:not([disabled]):hover {
    box-shadow: 0 4px 8px var(--sao-paulo-60);
  }

  &:active {
    background-color: var(--sao-paulo-60);
    border-color: var(--sao-paulo-60);
  }
`
